import { vm } from "../socket/config.js";
import { sendMessageToServer, updateVersion } from "../socket/events.js";
import {
    targetToName,
    nameToTarget,
    setLocalFlag,
} from "../utils/scratch-helpers.js";
import { setPauseEventHandling } from "../vm/overrides.js";

export const onSpriteAdd = async (data) => {
    setPauseEventHandling(true);
    try {
        const originalTarget = vm.editingTarget;
        await vm.addSprite(data.data.spriteData);

        if (
            !!originalTarget &&
            !!vm.runtime.getTargetById(originalTarget.id)
        ) {
            vm.editingTarget = originalTarget;
            vm.runtime.setEditingTarget(originalTarget);
        }
    } catch (e) {
        console.error("Error adding remote sprite:", e);
    } finally {
        setPauseEventHandling(false);
    }
};

export const onSpriteDelete = async (data) => {
    const targetName = data.data.target;
    const targetToDelete = nameToTarget(targetName);
    if (!targetToDelete) return;

    setLocalFlag(true);
    await vm.deleteSprite(targetToDelete.id);
    vm.emitWorkspaceUpdate();
};

export const onSpriteRename = (data) => {
    const { oldName, newName } = data.data;
    const target = nameToTarget(oldName);
    if (!target) return;

    setLocalFlag(true);
    vm.renameSprite(target.id, newName);
};
